import {
  TaxonomyGeneric,
  TaxonomyTheme,
} from '../implementations';

const mappers = {
  expertises: TaxonomyGeneric,
  technologies: TaxonomyGeneric,
  project_types: TaxonomyGeneric,
  themes: TaxonomyTheme,
};

export default mappers;
